// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { PopupForm } from './popup-form';
import { prepareUrl, getComponent } from './common';

/**
 * @class Jsw.AjaxPopupForm
 * @extends Jsw.PopupForm
 */
export const AjaxPopupForm = Class.create(PopupForm, {
    _initConfiguration($super, config) {
        $super(config);

        this._url = this._getConfigParam('url');
    },

    _initComponentElement($super) {
        $super();

        this._componentElement.down('.popup-content-area').update(`<div class="ajax-loading">${this.lmsg('waitMsg')}</div>`);
        new Ajax.Request(prepareUrl(this._url), {
            method: 'get',
            onSuccess: this._onSuccess.bind(this),
        });
    },

    _onSuccess(transport) {
        this._componentElement.down('.popup-content-area').update(transport.responseText);
        (function () {
            this._componentElement.down('form').writeAttribute('action', prepareUrl(this._url));
            const cancelBtn = getComponent('btn-cancel');
            cancelBtn.removeEventObserver('click', cancelBtn._handler);
            cancelBtn._handler = function () {
                this.hide();
            }.bind(this);
            cancelBtn.addEventObserver('click', cancelBtn._handler);
        }).bind(this).defer();
    },
});



// WEBPACK FOOTER //
// ./jsw/ajax-popup-form.js